export type DMO = "zandvoort" | "haarlem";
export const dmoAsArray = ["zandvoort", "haarlem"]; // Should mirror type DMO
